import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const CommitIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.79997 12L8.69997 8.09998C9.08657 7.71338 9.08657 7.08658 8.69997 6.69998C8.31337 6.31338 7.68657 6.31338 7.29997 6.69998L2.70708 11.2929C2.31655 11.6834 2.31655 12.3166 2.70708 12.7071L7.36357 17.3636C7.71505 17.7151 8.28489 17.7151 8.63637 17.3636L8.76358 17.2364C9.11505 16.8849 9.11505 16.3151 8.76357 15.9636L4.79997 12ZM19.2 12L15.3 8.09998C14.9134 7.71338 14.9134 7.08658 15.3 6.69998C15.6866 6.31338 16.3134 6.31338 16.7 6.69998L21.2929 11.2929C21.6834 11.6834 21.6834 12.3166 21.2929 12.7071L16.6364 17.3636C16.2849 17.7151 15.715 17.7151 15.3636 17.3636L15.2364 17.2364C14.8849 16.8849 14.8849 16.3151 15.2364 15.9636L19.2 12Z"
      />
    </Icon>
  );
};
